import React from 'react'
import { VStack } from '../../../parts/bases/VStack'
import {
  Layout as GlobalNavigationLayout,
  Props as GlobalNavigationLayoutProps,
} from '../../../parts/commons/GlobalNavigationLayout/Layout'
import * as TabBar from './TabBar'
import { HStack } from '../../../parts/bases/HStack'
import { Head } from '@/src/views/parts/commons/Head'
import { Center } from '@/src/views/parts/bases/Center'
import Image from 'next/image'
import NoAmImage from '@/public/images/noAm.png'
import { useTranslation } from 'react-i18next'
import { ExternalUrlService } from '@/src/services/ExternalUrlService'
import { Activity } from '../components/Activity'
import { Information } from '../components/Information'
import { Others } from '../components/Others'
import { Status } from '../components/Status'
import { Showcase } from '../components/Showcase'
import { Craft } from '../components/Craft'

export type Props = {
  status: 'VISIBLE' | 'LOADING' | 'NO_NFTS'
  GlobalNavigationLayoutProps: GlobalNavigationLayoutProps
  TabBarProps: TabBar.Props
}

export const Layout: React.VFC<Props> = (props) => {
  const { t } = useTranslation()
  return (
    <>
      <Head title={props.TabBarProps.activeTab} />
      <GlobalNavigationLayout {...props.GlobalNavigationLayoutProps}>
        <VStack className="flex-1">
          <HStack className="p-9">
            <h1 className="text-4xl font-bold text-white" style={{ textShadow: '#805BE7 1px 0 10px' }}>
              ArcadeMachine Manager
            </h1>
          </HStack>
          {props.status === 'LOADING' ? (
            <Center className="h-full w-full">
              <div className="flex justify-center">
                <div className="h-16 w-16 animate-spin rounded-full border-[3px] border-white border-t-transparent border-opacity-70"></div>
              </div>
            </Center>
          ) : null}
          {props.status === 'NO_NFTS' ? (
            <Center className="h-full w-full">
              <HStack className="items-center">
                <Image src={NoAmImage} width={250} height={250} objectFit="contain" alt="" />
                <VStack className="ml-10 items-center">
                  <span className="whitespace-pre-wrap text-white">
                    {t('ArcadeMachineManagerPage.NoNFTs')}
                  </span>
                  <a href={ExternalUrlService.getTofuNftAkiverseAMPage()} target={'_blank'}>
                    <HStack className="mt-4 items-center rounded-full border border-akiverse-pink px-6 py-2">
                      <Image
                        src={require('@/public/images/tofuNFTLogo.png')}
                        width="30"
                        height={30}
                        objectFit="contain"
                        alt=""
                      />
                      <span className="ml-4 font-bold text-white">LINK</span>
                    </HStack>
                  </a>
                </VStack>
              </HStack>
            </Center>
          ) : null}
          {props.status === 'VISIBLE' ? (
            <>
              <VStack className="ml-6">
                <TabBar.Layout {...props.TabBarProps} />
              </VStack>
              <VStack className="h-full w-full">
                {props.TabBarProps.activeTab === 'Status' ? <Status /> : null}
                {props.TabBarProps.activeTab === 'Showcase' ? <Showcase /> : null}
                {props.TabBarProps.activeTab === 'Craft' ? <Craft /> : null}
                {props.TabBarProps.activeTab === 'Activity' ? <Activity /> : null}
                {props.TabBarProps.activeTab === 'Information' ? <Information /> : null}
                {props.TabBarProps.activeTab === 'Others' ? <Others /> : null}
              </VStack>
            </>
          ) : null}
        </VStack>
      </GlobalNavigationLayout>
    </>
  )
}
